import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ErpLayout } from '../ErpLayout';
import { ErpEntities } from "../ErpEntities";
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class AccountViewPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout
                {...this.props}
                mode={ErpScopeMode.None}
                pages={{ entity: ErpEntities.account(this.props), view: {} }}
            >
                <></>
            </ErpLayout>
        );
    }
}